module.exports = __webpack_public_path__ + "img/airtable.1896cd15.svg";